module.exports = __webpack_public_path__ + "ir.f0236e88a274e52cd801.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/ir.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/ir.svg
// module chunks = styles